// /src/pages/private/members/calendarTools/calendar/api/calendarApi.js

import axios from "axios";

export async function calendarLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    "/api/user/calendar-last-seen",
    typeof lastSeenWsLogId === "undefined" ? {} : { lastSeenWsLogId },
    { withCredentials: true }
  );
  return data;
}

export async function getCalendarDiff() {
  const { data } = await axios.post("/api/user/calendar-diff", {}, { withCredentials: true });
  return data;
}

/** Same data as WS `calendar:subscribe` — load grid via HTTP (roster-style), WS only for invalidation. */
export async function fetchCalendarPeriodEvents(startDate, endDate) {
  const { data } = await axios.post(
    "/api/user/calendar-events-period",
    { startDate, endDate },
    { withCredentials: true }
  );
  return data;
}
